module.exports = __webpack_public_path__ + "img/7-02.58e58814.png";